import {useAuth} from 'app/modules/auth'
import {GetCustomMenu} from 'app/services/commonService'
import {ErrorHandler} from 'app/shared/Alfacom/ErrorHandler/ErrorHandler'
import {GetModuleColor, GetModuleIcon, GetModulePath, GetModuleText, Group, Module, Role} from 'app/shared/Common/Enums'
import {HasPermissionInGroup, HasPermissionInRole} from 'app/shared/Common/Util'
import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItem} from './AsideMenuItem'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuSub} from './AsideMenuSub'

export function AsideMenuMain() {
  const {currentUser} = useAuth()
  const intl = useIntl()
  const [customMenuTitle, setCustomMenuTitle] = useState<string>()
  const [customMenuIcon, setCustomMenuIcon] = useState<string>('far fa-question-circle')
  const [customSubMenu, setCustomSubMenu] = useState<any>([])

  useEffect(() => {
    loadCustomMenu()
  }, [])

  function loadCustomMenu() {
    if (currentUser) {
      GetCustomMenu()
        .then((respond: any) => {
          if (respond.status == 200) {
            setCustomMenuTitle(respond.data.menuTitle)
            if (respond.data.menuIcon && respond.data.menuIcon.length > 0) setCustomMenuIcon(respond.data.menuIcon)
            setCustomSubMenu(respond.data.subMenus)
          } else {
            console.error(`Error - Loading Custom Menu. Message: ${respond.data.message}`)
          }
        })
        .catch((error) => {
          ErrorHandler(error)
        })
    }
  }

  return (
    <>
      <div className='d-flex flex-column align-items-center align-items-lg-start gap-4'>
        {HasPermissionInRole(currentUser, [Role.EXT_Report_Full, Role.EXT_Report_Read]) &&
          HasPermissionInGroup(currentUser, [Group.Member_User_Administrator, Group.Member_Normal_User, Group.Member_Stakeholder]) && (
            <AsideMenuItem
              to={GetModulePath(Module.Dashboard)}
              variant={GetModuleColor(Module.Dashboard)}
              biIcon={GetModuleIcon(Module.Dashboard)}
              title={GetModuleText(Module.Dashboard)}
            />
          )}

        {HasPermissionInRole(currentUser, [Role.EXT_Submission_Full, Role.EXT_Submission_Read]) &&
          HasPermissionInGroup(currentUser, [Group.Member_User_Administrator, Group.Member_Normal_User, Group.Member_Stakeholder]) && (
            <AsideMenuItem
              to={GetModulePath(Module.Submission)}
              variant={GetModuleColor(Module.Submission)}
              biIcon={GetModuleIcon(Module.Submission)}
              title={GetModuleText(Module.Submission)}
            />
          )}

        {HasPermissionInRole(currentUser, [Role.EXT_Submission_Full, Role.EXT_Submission_Read]) && (
          <AsideMenuItem
            to={GetModulePath(Module.Pledge)}
            variant={GetModuleColor(Module.Pledge)}
            faIcon={GetModuleIcon(Module.Pledge)}
            title={GetModuleText(Module.Pledge)}
          />
        )}

        <AsideMenuItem
          to={GetModulePath(Module.Directory)}
          variant={GetModuleColor(Module.Directory)}
          biIcon={GetModuleIcon(Module.Directory)}
          title={GetModuleText(Module.Directory)}
        />

        {HasPermissionInRole(currentUser, [Role.EXT_Report_Full, Role.EXT_Report_Read]) &&
          HasPermissionInGroup(currentUser, [Group.Member_User_Administrator, Group.Member_Normal_User, Group.Member_Stakeholder]) && (
            <AsideMenuItem
              to={GetModulePath(Module.Reports)}
              variant={GetModuleColor(Module.Reports)}
              biIcon={GetModuleIcon(Module.Reports)}
              title={GetModuleText(Module.Reports)}
            />
          )}

        {HasPermissionInRole(currentUser, [Role.EXT_Maintenance_Full, Role.EXT_Maintenance_Read, Role.EXT_User_Full, Role.EXT_User_Read]) && (
          <AsideMenuItemWithSub
            to={GetModulePath(Module.Maintenance)}
            variant={GetModuleColor(Module.Maintenance)}
            biIcon={GetModuleIcon(Module.Maintenance)}
            title={GetModuleText(Module.Maintenance)}
            width={125}
            widthLg={150}
          >
            {HasPermissionInRole(currentUser, [Role.EXT_User_Full, Role.EXT_User_Read]) && (
              <AsideMenuSub
                column={12}
                to={GetModulePath(Module.Maintenance_User)}
                variant={GetModuleColor(Module.Maintenance_User)}
                faIcon={GetModuleIcon(Module.Maintenance_User)}
                title={GetModuleText(Module.Maintenance_User)}
              ></AsideMenuSub>
            )}
            {HasPermissionInRole(currentUser, [Role.EXT_Maintenance_Full, Role.EXT_Maintenance_Read]) && (
              <AsideMenuSub
                column={12}
                to={GetModulePath(Module.Maintenance_List_Category)}
                variant={GetModuleColor(Module.Maintenance_List_Category)}
                faIcon={GetModuleIcon(Module.Maintenance_List_Category)}
                title={GetModuleText(Module.Maintenance_List_Category)}
              ></AsideMenuSub>
            )}
          </AsideMenuItemWithSub>
        )}

        {customSubMenu.length > 0 && (
          <>
            {customSubMenu.length === 1 && (
              <>
                {customSubMenu.map((menu: any, index: any) => {
                  var menuName = menu.Key
                  var fileName = menu.Value.split('.')[0]
                  return <AsideMenuItem biIcon={customMenuIcon} key={index} title={menuName} to={`/main/menu/${index}/${fileName}`} target='_blank' />
                })}
              </>
            )}
            {customSubMenu.length > 1 && (
              <AsideMenuItemWithSub to='#' variant='' biIcon={customMenuIcon} title={customMenuTitle!} width={200} widthLg={225}>
                <>
                  {customSubMenu.map((menu: any, index: any) => {
                    var menuName = menu.Key
                    var fileName = menu.Value.split('.')[0]
                    return (
                      <AsideMenuSub
                        column={12}
                        variant='dark'
                        key={index}
                        title={menuName}
                        to={`/main/menu/${index}/${fileName}`}
                        target='_blank'
                        textAlign='left'
                      />
                    )
                  })}
                </>
              </AsideMenuItemWithSub>
            )}
          </>
        )}
      </div>
    </>
  )
}
